import loadModule from './loader'
import dynamic from './dynamic'
import * as TYPES from 'component-index'

const loaded = {}

function getComponent (c, preload = false) {
  let ccId, type
  if(typeof c === 'string') type = c
  else {
    type = c.type
    ccId = c.ccId
  }
  if (type === 'Custom') {
    let buildId
    if (typeof window !== 'undefined') {
      buildId = window.__polystack_data__?.assignmentVersionId
    }
    ccId = [ccId, buildId].filter(Boolean).join('.')
    if(preload) return loadModule(ccId)
    return dynamic(() => loadModule(ccId))
  }
  const T = TYPES[type || 'Container'] || TYPES.Container
  if(preload) {
    return T().then(C => loaded[type] = dynamic(C.default))
  }
  if(loaded[type]) return loaded[type]
  return dynamic(T)
}

export default getComponent
